import moment from 'moment'
import momentTimeZone from 'moment-timezone'
import { mapGetters } from 'vuex'
import config from 'services/config'
import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'

export default {
    methods: {
        boldTranslationDomainVariable (text) {
            return '<span style="color:#000; font-weight: 600;">' + text + '</span>'
        },
        getMobileColumnClasses (column) {
            if (!column.classes) {
                return ''
            }
            return column.classes
        },
        signUpForDigitalClassRoom () {
            const text = this.$t('DigitalClassrooms.confirm_signup_message',
                { TrainingName: this.boldTranslationDomainVariable(this.event.title),
                    TrainingDate: this.boldTranslationDomainVariable(this.getEventDates[0]),
                    TrainingTime: this.boldTranslationDomainVariable(this.getEventTime) })
            this.showModal(text, this.onSignUpAccepted)
        },
        cancelSignUpForDigitalClassRoom () {
            const text = this.$t('DigitalClassrooms.confirm_signup_cancel_message',
                { TrainingName: this.boldTranslationDomainVariable(this.event.title),
                    TrainingDate: this.boldTranslationDomainVariable(this.getEventDates[0]),
                    TrainingTime: this.boldTranslationDomainVariable(this.getEventTime) })
            this.showModal(text, this.onSignUpCancelAccepted)
        },
        showModal (mainText, onYes) {
            this.$modal.show('dialog', {
                text: mainText,
                buttons: [
                    {
                        title: this.$t('General.no'),
                        handler: () => {
                            this.$modal.hide('dialog')
                        }
                    },
                    {
                        title: this.$t('General.yes'),
                        default: true,
                        handler: onYes
                    }
                ]
            })
        },
        getIntervalEventTime (session) {
            return moment(session.startDateAndTime).format('HH:mm') + '-' +
            moment(session.endDateAndTime).format('HH:mm')
        },
        getIntervalEventDate (session) {
            return moment(session.startDateAndTime).format('DD.MM.YYYY')
        },
        getIntervalEventDuration (session) {
            let start = moment(session.startDateAndTime)
            let end = moment(session.endDateAndTime)

            const trainingDays = end.diff(start, 'days') + 1
            const differenceInHours = end.diff(start, 'hours')

            if (trainingDays === 1 && differenceInHours < 1) {
                return `${end.diff(start, 'minutes')} ${this.$t('DigitalClassrooms.minutes')}`
            }

            if (trainingDays === 1 && differenceInHours < 7) {
                if (end.diff(start, 'minutes') % 60 !== 0) {
                    return `${differenceInHours} ${this.$t('DigitalClassrooms.hoursAbbreviation')} ${end.diff(start, 'minutes') % 60} ${this.$t('DigitalClassrooms.minutesAbbreviation')}`
                }
                return `${differenceInHours} ${this.$t('DigitalClassrooms.hours')}`
            }
            return `${trainingDays} ${this.$t('DigitalClassrooms.days')}`
        }
    },
    computed: {
        ...mapGetters({
            isCourseCompleted: 'CompletedCourses/isCourseCompleted',
            digitalClassRoomTrainingByCourseId: 'Courses/getDigitalClassRoomEventsWithCourseId'
        }),
        getEventTime () {
            return moment(this.event.sessions[0].startDateAndTime).format('HH:mm') + '-' +
                moment(this.event.sessions[0].endDateAndTime).format('HH:mm')
        },
        getEventDates () {
            const dates = this.event.sessions.map(date => {
                return formattedDateForCountry(date.endDateAndTime)
            })
            return dates
        },
        getEventDuration () {
            let start = moment(this.event.sessions[0].startDateAndTime)
            let end = moment(this.event.sessions[this.event.sessions.length - 1].endDateAndTime)

            const trainingDays = end.diff(start, 'days') + 1
            const differenceInHours = end.diff(start, 'hours')

            if (trainingDays === 1 && differenceInHours < 1) {
                return `${end.diff(start, 'minutes')} ${this.$t('DigitalClassrooms.minutes')}`
            }

            if (trainingDays === 1 && differenceInHours < 7) {
                if (end.diff(start, 'minutes') % 60 !== 0) {
                    return `${differenceInHours} ${this.$t('DigitalClassrooms.hoursAbbreviation')} ${end.diff(start, 'minutes') % 60} ${this.$t('DigitalClassrooms.minutesAbbreviation')}`
                }
                return `${differenceInHours} ${this.$t('DigitalClassrooms.hours')}`
            }
            return `${trainingDays} ${this.$t('DigitalClassrooms.days')}`
        },
        getIntervalEventsTotalDuration () {
            let totalHours = 0
            let totalDays = 0
            for (const session of this.event.sessions) {
                const startDate = new Date(session.startDateAndTime)
                const endDate = new Date(session.endDateAndTime)
                const durationInMilliseconds = endDate - startDate
                const durationInHours = durationInMilliseconds / (1000 * 60 * 60)

                if (durationInHours > 7) {
                    totalDays += 1
                } else {
                    totalHours += durationInHours
                }
            }

            if (totalHours > 7) {
                totalDays += Math.floor(totalHours / 7)
                totalHours %= 7
            }

            if (totalDays > 0) {
                return totalHours > 0
                    ? `${totalDays} ${this.$t('DigitalClassrooms.days')} ${totalHours} ${this.$t('DigitalClassrooms.hours')}`
                    : `${totalDays} ${this.$t('DigitalClassrooms.days')}`
            }

            return `${totalHours} ${this.$t('DigitalClassrooms.hours')}`
        },
        userHasNoAccessButHasSignedUp () {
            return this.isLoggedIn && this.hasSignedUpToSomeEvent && this.course.demo
        },
        getEventSeats () {
            if (this.event.seatsAvailable <= 0) {
                return this.$t('DigitalClassrooms.full')
            }
            return this.event.seatsAvailable
        },
        isUserSignedToEvent () {
            return this.signedUpEvents.filter(event => event.training.id === this.event.id && event.subscriptionStatus === 'ok').length > 0
        },
        eventIsNotFull () {
            return this.event.seatsAvailable > 0
        },
        isSignUpClosedForEvent () {
            switch (config.appLanguage) {
            case 'fi':
                const packagesToCheck = ['fi-cloudskills', 'fi-cloudpro']
                if (this.course.availableInPackages.some(coursePackage => packagesToCheck.includes(coursePackage.id))) {
                    // Special condition only for CloudSkills and CloudPro courses, use the 2 days of buffer to only these packages
                    return moment().unix() > (moment(this.event.firstTrainingDateAndTime).unix() - config.digitalClassRoomBufferTime)
                } else {
                    return moment().unix() > (moment(this.event.firstTrainingDateAndTime).unix() - 60)
                }
            case 'se':
                return momentTimeZone().tz('Europe/Stockholm').unix() > momentTimeZone(this.event.firstTrainingDateAndTime).tz('Europe/Stockholm').unix()
            case 'no':
                return momentTimeZone().tz('Europe/Oslo').unix() > momentTimeZone(this.event.firstTrainingDateAndTime).tz('Europe/Oslo').unix()
            }
        },
        hasEventStarted () {
            return moment().unix() > moment(this.event.sessions[0].startDateAndTime).unix()
        },
        hasEventEnded () {
            return moment().unix() > moment(this.event.sessions[this.event.sessions.length - 1].endDateAndTime).unix()
        },
        hasTeamsUrl () {
            return this.event.classroomUrl
        },
        isCourseTestExpired () {
            const now = moment().unix()
            const courseTestExpirationTime = (moment(this.event.firstTrainingDateAndTime).unix() + config.digitalClassRoomBufferTime)
            return now > courseTestExpirationTime
        },
        isDigitalClassRoomTestCompleted () {
            return this.isCourseCompleted(this.event.course.id)
        },
        doesPastExpiredEventHaveTrainings () {
            const event = this.digitalClassRoomTrainingByCourseId(this.event.course.id)
            if (!event) {
                return false
            }
            return true
        }
    }
}
